/**
 * 지도 UI 공용 수치. 컴포넌트 모듈에 두면 `ItemMapView` ↔ `ItemMapList` 처럼
 * 서로를 import 하는 순환 참조가 생긴다.
 */
/** ItemMapList 카드 캐러셀 밴드의 고정 높이. */
export const CARD_LIST_HEIGHT = 261;
